import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Form } from "../../../base/views/useForm";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialFValues = {
  licenseid: 0,
  licenseno: "",
  licensetype: "",
  validfrom: null,
  validto: null,
  email: "",
  emaildate: null,
};

export default function LicenseManagementForm(props) {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [addLicenseData, setState] = useState(initialFValues);

  const { addOrEdit, recordForEdit, addLicense, editLicense } = props;

  const validate = (fieldValues = addLicenseData) => {
    let temp = { ...errors };

    if ("licenseno" in fieldValues) {
      temp.licenseno =
        fieldValues.licenseno === "" ? "License No is required" : "";
    }

    if ("email" in fieldValues)
      temp.email =
        fieldValues.email === ""
          ? "Email is required"
          : /$^|.+@.+..+/.test(fieldValues.email)
          ? ""
          : "Invalid Email.";

    if ("licensetype" in fieldValues) {
      temp.licensetype =
        fieldValues.licensetype === "" ? "License Type is required" : "";
    }
    if ("emaildate" in fieldValues) {
      temp.emaildate =
        fieldValues.emaildate === ""
          ? "Email Notification Date is required"
          : "";
    }

    if ("emaildate" in fieldValues) {
      temp.emaildate =
        fieldValues.emaildate === null
          ? "Email Notification Date is required"
          : "";
    }

    if ("validfrom" in fieldValues) {
      temp.validfrom =
        fieldValues.validfrom === null ? "Valid From is required" : "";
    }

    if ("validto" in fieldValues) {
      temp.validto = fieldValues.validto === null ? "Valid To is required" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addLicenseData,
      [name]: value,
    });
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (addLicenseData.licenseid === 0) {
        addLicense({
          ...addLicenseData,
          storeid: props.storeid,
          userid: props.userid,
        });
      } else {
        editLicense({
          ...addLicenseData,
          storeid: props.storeid,
          userid: props.userid,
        });
      }
      addOrEdit(resetForm);
    }
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  const handleValidFromDateChange = (date) => {
    setState({
      ...addLicenseData,
      validfrom: date,
    });
  };

  const handleValidToDateChange = (date) => {
    setState({
      ...addLicenseData,
      validto: date,
    });
  };

  const handleEmailNotificationDateChange = (date) => {
    setState({
      ...addLicenseData,
      emaildate: date,
    });
  };

  useEffect(() => {
    if (recordForEdit != null)
      setState({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={HandleSubmit}>
      <Container component="main" maxWidth="xs">
        <div className={classes.form}>
          <Grid container>
            <TextField
              autoFocus
              value={addLicenseData.licenseno}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              id="licenseno"
              label="License No"
              name="licenseno"
              autoComplete="licenseno"
              {...(errors.licenseno && {
                error: true,
                helperText: errors.licenseno,
              })}
            />
            <TextField
              value={addLicenseData.licensetype}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              id="licensetype"
              label="License Type"
              name="licensetype"
              autoComplete="licensetype"
              {...(errors.licensetype && {
                error: true,
                helperText: errors.licensetype,
              })}
            />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  margin="normal"
                  id="emailNotificationDate"
                  label="Email Notification Date"
                  format="MM/dd/yyyy"
                  value={addLicenseData.emaildate}
                  onChange={handleEmailNotificationDateChange}
                  style={{ marginLeft: -50 }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  {...(errors.emaildate && {
                    error: true,
                    helperText: errors.emaildate,
                  })}
                />
              </Grid>
            </MuiPickersUtilsProvider>
            <TextField
              value={addLicenseData.email}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              {...(errors.email && {
                error: true,
                helperText: errors.email,
              })}
            />

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  margin="normal"
                  id="validFromDate"
                  label="Valid From"
                  format="MM/dd/yyyy"
                  value={addLicenseData.validfrom}
                  onChange={handleValidFromDateChange}
                  style={{ marginLeft: -50 }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  {...(errors.validfrom && {
                    error: true,
                    helperText: errors.validfrom,
                  })}
                />
              </Grid>
            </MuiPickersUtilsProvider>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  margin="normal"
                  id="validToDate"
                  label="Valid To"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={addLicenseData.validto}
                  onChange={handleValidToDateChange}
                  style={{ marginLeft: -50 }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  {...(errors.validto && {
                    error: true,
                    helperText: errors.validto,
                  })}
                />
              </Grid>
            </MuiPickersUtilsProvider>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                style={{
                  width: "20vw",
                  backgroundColor: "rgb(22, 177, 255)",
                  borderRadius: "0.5rem",
                }}
                type="submit"
              >
                Save
              </Button>
            </div>
          </Grid>
        </div>
      </Container>
    </Form>
  );
}
